import { LitElement, html, svg } from 'lit';

export class IconUpload24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Pil opp fra harddisk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15.75v-12M7.54 8.211 12 3.75l4.462 4.461M.75 15.875v1.374a3 3 0 0 0 3 3h16.5a3 3 0 0 0 3-3v-1.374"></path></svg>`; }
}
if (!customElements.get('f-icon-upload24', IconUpload24)) {
  customElements.define('f-icon-upload24', IconUpload24);
}